var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Confirm", {
    ref: "confirmRef",
    attrs: { "max-width": _vm.maxWidth },
    scopedSlots: _vm._u([
      {
        key: "card-title",
        fn: function (ref) {
          var close = ref.close
          return [
            _c("v-card-title", { staticClass: "alert-dialog__header" }, [
              _c(
                "div",
                { staticClass: "alert-dialog__header-inner" },
                [
                  _c("span", { staticClass: "text-h6 alert-dialog__title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.step === 1
                            ? _vm.$t("title_step1")
                            : _vm.$t("title_step2")
                        ) +
                        "\n        "
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "alert-dialog__close",
                      attrs: { depressed: "", icon: "" },
                      on: { click: close },
                    },
                    [
                      _c("v-icon", { attrs: { size: "18" } }, [
                        _vm._v("close"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
      },
      {
        key: "content",
        fn: function () {
          return [
            _vm.step === 1
              ? _c(
                  "div",
                  {
                    staticClass:
                      "limits-dialog__panel limits-dialog__panel--step1",
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "limits-dialog__lead limits-dialog__lead--center",
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("lead_step1")) +
                            "\n      "
                        ),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "limits-dialog__link",
                        attrs: { type: "button" },
                        on: { click: _vm.goLearnMore },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("btn_learn_more")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "limits-dialog__panel limits-dialog__panel--step2",
                  },
                  [
                    _c("p", { staticClass: "limits-dialog__intro" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("intro_step2")) +
                          "\n      "
                      ),
                    ]),
                    _c("p", { staticClass: "limits-dialog__factors-heading" }, [
                      _vm._v(_vm._s(_vm.$t("factors_heading"))),
                    ]),
                    _c(
                      "ul",
                      { staticClass: "limits-dialog__list" },
                      _vm._l(_vm.$t("factors"), function (factor, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "limits-dialog__list-item",
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(factor) + "\n        "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("p", { staticClass: "limits-dialog__outro" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("outro_step2")) +
                          "\n      "
                      ),
                    ]),
                  ]
                ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function (ref) {
          var close = ref.close
          return [
            _vm.step === 1
              ? [_c("span")]
              : _vm.showUpgradeButton
              ? [
                  _c(
                    "div",
                    { staticClass: "limits-dialog__actions" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "limits-dialog__upgrade text-none",
                          attrs: {
                            color: "primary",
                            depressed: "",
                            "min-width": "187",
                            to: { name: "Upgrade" },
                          },
                          on: { click: close },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("btn_upgrade")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              : [_c("span")],
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }